import { useRef } from "react";
import { createPortal } from "react-dom";

import classnames from "classnames";


export interface ModalProps {
  id?: string;
  children?: JSX.Element | string;
  className?: string;
  opened: boolean;
  onClose: () => void;
  title?: string;
}

export const Modal = ({
  id,
  children,
  opened,
  onClose,
  className,
  title,
}: ModalProps) => {
  const ref = useRef<HTMLDivElement>(null);

  const tree = (
    <>
      {opened && (
        <div id={id} className="fixed inset-0 z-50 overflow-y-auto">
          <div className="relative flex min-h-screen items-center justify-center p-4 sm:p-6 lg:p-8">
            <div
              onClick={() => onClose()}
              className="fixed inset-0 z-0 bg-content-950/45 backdrop-blur-sm dark:bg-content-950/70"
            />
            <div
              ref={ref}
              role="dialog"
              aria-modal="true"
              aria-label={title}
              className={classnames(
                "relative z-10 mx-auto w-full max-w-2xl transform rounded-2xl border border-white/40 bg-base-100 p-6 text-left text-content-900 shadow-xl shadow-content-900/10 dark:border-primary-800/55 dark:bg-content-900 dark:text-content-100 dark:shadow-content-950/40 sm:p-8",
                className,
              )}
            >
              {children}
            </div>
          </div>
        </div>
      )}
    </>
  );

  if (typeof document === "undefined") {
    return null;
  }

  return createPortal(tree, document.body);
};
